// ═══════════════════════════════════════════════════════════════
// HotWash — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '@mantine/core';
import {
  IconLayoutDashboard, IconEye, IconPlus, IconChartBar, IconUpload,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/hotwash', icon: IconLayoutDashboard, exact: true },
  { label: 'Observations', path: '/hotwash/observations', icon: IconEye },
  { label: 'Submit', path: '/hotwash/submit', icon: IconPlus },
  { label: 'Analytics', path: '/hotwash/analytics', icon: IconChartBar, minLevel: 'editor' },
  { label: 'Import', path: '/hotwash/import', icon: IconUpload, minLevel: 'editor' },
];

export default function HotWashLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('hotwash', NAV_ITEMS);

  // Hide sub-nav on incident detail pages (they have their own breadcrumbs)
  const isDetail = pathname.startsWith('/hotwash/incident/');

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
        <Breadcrumbs
          items={[
            { label: 'Hub', to: '/' },
            { label: 'HotWash', to: '/hotwash' },
            ...(currentPage && currentPage.path !== '/hotwash' ? [{ label: currentPage.label }] : []),
          ]}
        />
        <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
          {visibleItems.map(item => {
            const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                variant={active ? 'filled' : 'light'}
                color={active ? brand.blurple : 'gray'}
                size="xs"
                leftSection={<item.icon size={14} />}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Group>
        </>
      )}
      <Outlet />
    </div>
  );
}
